import { useRef, useState, useCallback } from 'react';
import { Sidebar } from '@/components/Sidebar';
import { SqlEditor } from '@/components/SqlEditor';
import { ResultsGrid } from '@/components/ResultsGrid';
import { PolicyPanel } from '@/components/PolicyPanel';
import './EditorPage.css';

const MIN_RESULTS_H = 60;
const MAX_RESULTS_H = 700;
const MIN_SIDEBAR_W = 160;
const MAX_SIDEBAR_W = 520;

export default function EditorPage() {
  const [resultsH, setResultsH]   = useState(520);
  const [sidebarW, setSidebarW]   = useState(420);

  const resultsDrag = useRef<{ y: number; h: number } | null>(null);
  const sidebarDrag = useRef<{ x: number; w: number } | null>(null);

  const onResultsDragStart = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    resultsDrag.current = { y: e.clientY, h: resultsH };
    const onMove = (ev: MouseEvent) => {
      if (!resultsDrag.current) return;
      const delta = resultsDrag.current.y - ev.clientY;
      setResultsH(Math.max(MIN_RESULTS_H, Math.min(MAX_RESULTS_H, resultsDrag.current.h + delta)));
    };
    const onUp = () => {
      resultsDrag.current = null;
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  }, [resultsH]);

  const onSidebarDragStart = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    sidebarDrag.current = { x: e.clientX, w: sidebarW };
    const onMove = (ev: MouseEvent) => {
      if (!sidebarDrag.current) return;
      const delta = ev.clientX - sidebarDrag.current.x;
      setSidebarW(Math.max(MIN_SIDEBAR_W, Math.min(MAX_SIDEBAR_W, sidebarDrag.current.w + delta)));
    };
    const onUp = () => {
      sidebarDrag.current = null;
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  }, [sidebarW]);

  return (
    <div
      className="editor-page"
      style={{ gridTemplateColumns: `${sidebarW}px 5px 1fr 280px` }}
    >
      <Sidebar />
      <div className="sidebar-resize-handle" onMouseDown={onSidebarDragStart} />
      <div
        className="editor-center"
        style={{ '--results-h': `${resultsH}px` } as React.CSSProperties}
      >
        <SqlEditor />
        <div className="results-resize-handle" onMouseDown={onResultsDragStart} />
        <ResultsGrid />
      </div>
      <PolicyPanel />
    </div>
  );
}
